import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=300813f8&scoped=true"
import script from "./ViewProduct.vue?vue&type=script&lang=js"
export * from "./ViewProduct.vue?vue&type=script&lang=js"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&id=300813f8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300813f8",
  null
  
)

export default component.exports